import Helpers from '../lib/Helpers'

export default product => {
  let baseClass = 'product-card'
  let element = 'a'

  if (!product.available) {
    baseClass += ' product-card--sold-out'
    element = 'div'
  }

  let productImage = ''

  if (product.featured_image) {
    productImage = product.featured_image
  }

  return `
    <${element}
      class="${baseClass}"
      href="${product.url}"
    >
      <div class="product-card__image">
        <img
          src="${productImage}"
          alt="${product.title}"
          height="480"
          width="350"
        />

        ${
          product.available
            ? ''
            : `
            <div class="product-card__badge">
              ${window.productStrings.soldOut}
            </div>`
        }
      </div>

      <div class="product-card__bottom">
        <div class="product-card__info">
          <div class="product-card__product-title">
            ${product.title}
          </div>
        </div>

        ${
          product.available
            ? `
            <div class="product-card__prices product-price">
              ${
                product.compare_at_price > product.price
                  ? `<span class="product-price__price">
                      ${Helpers.formatMoney(product.price)}
                    </span>

                    <strike class="product-price__compare-at-price">
                      ${Helpers.formatMoney(product.compare_at_price)}
                    </strike>`
                  : `<span class="product-price__price">
                      ${Helpers.formatMoney(product.price)}
                    </span>`
              }
            </div>`
            : ''
        }
      </div>
    </${element}>
  `
}
